import {
    Injectable,
} from '@angular/core';

import {
    StatusMenu,
} from '../../lib/core/models/status.model';

import {
    ChannelStatusMenuDatastore,
} from '../datastore/channel-status.datastore';


@Injectable({
    providedIn: 'root',
})
export class ChannelStatusMenuService {

    constructor(
        private _statusDatastore: ChannelStatusMenuDatastore,
    ) { }

    public get(id: string): StatusMenu {
        return this._statusDatastore.get(id);
    }

    public all(): StatusMenu[] {
        return this._statusDatastore.all();
    }
}
